/**
 * useLotsConfies — RP44-RP46 (délégation par lot de la DPGF et du CCTP).
 *
 * Source : GET /api/chantiers/{cid}/lots-confies
 *   { lots: [{lot_id, lot_nom, user_id, user_nom, partenaire, statut, statut_libelle, ...}],
 *     moi: { dpgf: {mode, lots, exclus, complete}, cctp: {...}, user_id, peut_confier, peut_valider },
 *     personnes: [{user_id, name, partenaire}] }
 *
 * mode « tous » : tout le document sauf `exclus` (lots confiés à d'autres) ;
 * mode « lots » : seulement ses lots confiés ; mode « aucun » : lecture seule.
 */
import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const VIDE = {
  lots: [],
  moi: {
    dpgf: { mode: "aucun", lots: [], exclus: [], complete: false },
    cctp: { mode: "aucun", lots: [], exclus: [], complete: false },
    peut_confier: false,
    peut_valider: false,
  },
  personnes: [],
};

export function peutEcrireLot(portee, lotId) {
  if (!portee) return false;
  if (portee.mode === "tous") return !(portee.exclus || []).includes(lotId);
  if (portee.mode === "lots") return (portee.lots || []).includes(lotId);
  return false;
}

export default function useLotsConfies(chantierId) {
  const [data, setData] = useState(VIDE);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    if (!chantierId) return;
    try {
      const r = await axios.get(`${API_URL}/api/chantiers/${chantierId}/lots-confies`, { withCredentials: true });
      setData({ ...VIDE, ...(r.data || {}) });
    } catch (e) {
      setData(VIDE);
    } finally {
      setLoaded(true);
    }
  }, [chantierId]);

  useEffect(() => { refresh(); }, [refresh]);

  const delegationDe = useCallback(
    (lotId) => (data.lots || []).find((d) => d.lot_id === lotId) || null,
    [data]
  );

  return { data, loaded, refresh, delegationDe };
}
